module.exports = __webpack_public_path__ + "components/flag/static/square/fi-b86c516b0f0596a5becccd32304e8c49.svg";